const CAKE = ({ ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10.7148 20C16.2377 20 20.7148 15.5228 20.7148 10C20.7148 4.47715 16.2377 0 10.7148 0C5.192 0 0.714844 4.47715 0.714844 10C0.714844 15.5228 5.192 20 10.7148 20Z"
        fill="#72C4C2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.24816 11.3377L4.24553 11.4593C4.24553 11.6133 4.25778 11.7651 4.28184 11.915H4.24553V12.1506C4.24551 12.2648 4.2523 12.3789 4.26588 12.4923C4.52969 14.6922 7.31613 16.4226 10.7148 16.4226C14.1136 16.4226 16.9 14.6918 17.1636 12.4923C17.1772 12.3789 17.184 12.2648 17.1839 12.1506V11.915H17.1476C17.1718 11.7643 17.184 11.6119 17.1839 11.4593C17.1839 11.4188 17.183 11.3782 17.1813 11.3377C17.084 9.03471 14.2258 7.18758 10.7148 7.18758C7.20391 7.18758 4.34572 9.03471 4.24816 11.3377ZM3.71659 11.3377C3.76472 9.93246 4.64256 8.75208 5.86472 7.94489C7.13128 7.10839 8.84737 6.60986 10.7144 6.60986C12.5814 6.60986 14.2975 7.10861 15.5641 7.94489C16.786 8.75208 17.6641 9.93224 17.7122 11.3377H17.7148V12.1506C17.7148 13.6096 16.8219 14.8346 15.5645 15.6648C14.298 16.5013 12.5821 17.0001 10.7148 17.0001C8.84759 17.0001 7.13172 16.5013 5.86516 15.665C4.60778 14.8349 3.71484 13.6094 3.71484 12.1508V11.3379H3.71703L3.71659 11.3377Z"
        fill="#606063"
      />
      <path
        d="M17.1843 12.1507C17.1843 14.5102 14.288 16.4229 10.7149 16.4229C7.14188 16.4229 4.24585 14.5102 4.24585 12.1507V11.4744H17.1843V12.1507Z"
        fill="#BEBEBE"
      />
      <path
        d="M17.1843 11.4596C17.1843 13.819 14.288 15.7318 10.7149 15.7318C7.14188 15.7318 4.24585 13.819 4.24585 11.4596C4.24585 9.10015 7.1421 7.18762 10.7149 7.18762C14.2878 7.18762 17.1843 9.10015 17.1843 11.4598V11.4596Z"
        fill="#FAF9FA"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.24111 10.2526V10.2607C5.24118 10.453 5.26655 10.6443 5.31658 10.8299H5.24111V11.0802C5.24111 11.1906 5.24942 11.2998 5.26583 11.4072C5.51236 13.0316 7.57583 14.2991 10.0849 14.2991C12.594 14.2991 14.6572 13.0312 14.904 11.4072C14.9204 11.299 14.9287 11.1897 14.9287 11.0802V10.8299H14.8532C14.9019 10.6494 14.9272 10.4634 14.9287 10.2765V10.2605V10.2524C14.9221 8.47836 12.756 7.04117 10.0851 7.04117C7.41417 7.04117 5.24811 8.47836 5.24155 10.2524L5.24111 10.2526ZM4.71021 10.2526V11.0802C4.71021 12.2461 5.41896 13.2086 6.38277 13.8495C7.35555 14.4962 8.66564 14.8772 10.0845 14.8772C11.5033 14.8772 12.8134 14.4962 13.7861 13.8495C14.7497 13.209 15.4587 12.2468 15.4587 11.0802V10.2607C15.4587 9.0948 14.75 8.1323 13.7861 7.4918C12.8134 6.84517 11.5033 6.46411 10.0845 6.46411C8.66564 6.46411 7.35555 6.84517 6.38277 7.4918C5.42136 8.13055 4.71327 9.0902 4.71021 10.2529V10.2526Z"
        fill="#633001"
      />
      <path
        d="M14.9278 11.0802C14.9278 12.8582 12.7594 14.2995 10.0843 14.2995C7.40919 14.2995 5.24072 12.8582 5.24072 11.0802V10.3248H14.9278V11.0802Z"
        fill="#FEDC90"
      />
      <path
        d="M14.9278 10.2603C14.9278 12.0383 12.7594 13.4796 10.0843 13.4796C7.40919 13.4796 5.24072 12.0387 5.24072 10.2603C5.24072 8.48183 7.4116 7.04114 10.0843 7.04114C12.757 7.04114 14.9278 8.48248 14.9278 10.2603Z"
        fill="#D1884F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.70061 8.52054V8.52863C6.70067 8.72085 6.72605 8.91222 6.77608 9.09782H6.70061V9.34807C6.70061 9.45854 6.70892 9.56769 6.72533 9.6751C6.97186 11.2995 9.03533 12.5674 11.5444 12.5674C14.0535 12.5674 16.1167 11.2995 16.3635 9.6751C16.3799 9.56686 16.3882 9.45754 16.3882 9.34807V9.09782H16.3127C16.3608 8.918 16.3871 8.73316 16.3882 8.54438V8.52841V8.52032C16.3816 6.74625 14.2155 5.30907 11.5446 5.30907C8.87367 5.30907 6.70761 6.74625 6.70105 8.52032L6.70061 8.52054ZM6.16992 8.52054V9.34807C6.16992 10.514 6.87867 11.4765 7.8427 12.1174C8.81548 12.7641 10.1256 13.1451 11.5444 13.1451C12.9632 13.1451 14.2733 12.7641 15.2461 12.1174C16.2097 11.4769 16.9186 10.5147 16.9186 9.34807V8.52863C16.9186 7.36269 16.2099 6.40019 15.2461 5.75925C14.2733 5.11263 12.9632 4.73157 11.5444 4.73157C10.1256 4.73157 8.81505 5.11307 7.84248 5.75947C6.88108 6.39822 6.17298 7.35788 6.16992 8.52054V8.52054Z"
        fill="#633001"
      />
      <path
        d="M16.3878 9.34812C16.3878 11.1261 14.2194 12.5675 11.5443 12.5675C8.86918 12.5675 6.70093 11.1261 6.70093 9.34812V8.59277H16.3881V9.34812H16.3878Z"
        fill="#FEDC90"
      />
      <path
        d="M16.3878 8.52867C16.3878 10.3067 14.2194 11.748 11.5443 11.748C8.86918 11.748 6.70093 10.3067 6.70093 8.52867C6.70093 6.75067 8.8694 5.30933 11.5445 5.30933C14.2196 5.30933 16.3881 6.75089 16.3881 8.52867H16.3878Z"
        fill="#D1884F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.24111 6.78875V6.79684C5.24118 6.98906 5.26655 7.18044 5.31658 7.36603H5.24111V7.61628C5.24111 7.72675 5.24942 7.83591 5.26583 7.94331C5.51236 9.56775 7.57583 10.8352 10.0849 10.8352C12.594 10.8352 14.6572 9.56731 14.904 7.94331C14.9204 7.83508 14.9287 7.72576 14.9287 7.61628V7.36625H14.8532C14.9019 7.18574 14.9272 6.99976 14.9287 6.81281V6.79684V6.78875C14.9215 5.01425 12.7558 3.5775 10.0849 3.5775C7.41396 3.5775 5.24746 5.01425 5.24111 6.78875ZM4.71021 6.78875V7.61628C4.71021 8.78222 5.41896 9.74472 6.38277 10.3857C7.35555 11.0323 8.66564 11.4133 10.0845 11.4133C11.5033 11.4133 12.8134 11.0323 13.7861 10.3857C14.7497 9.74516 15.4587 8.78288 15.4587 7.61628V6.79684C15.4587 5.63091 14.75 4.66841 13.7861 4.02747C12.8136 3.38106 11.5035 3 10.0849 3C8.6663 3 7.35555 3.38106 6.38299 4.02769C5.42158 4.66687 4.71349 5.62609 4.71021 6.78875V6.78875Z"
        fill="#633001"
      />
      <path
        d="M14.9278 7.61631C14.9278 9.39431 12.7594 10.8357 10.0843 10.8357C7.40919 10.8357 5.24072 9.39409 5.24072 7.61631V6.86096H14.9278V7.61631V7.61631Z"
        fill="#FEDC90"
      />
      <path
        d="M14.9278 6.79664C14.9278 8.57464 12.7594 10.016 10.0843 10.016C7.40919 10.016 5.24072 8.57464 5.24072 6.79664C5.24072 5.01864 7.4116 3.57751 10.0843 3.57751C12.757 3.57751 14.9278 5.01864 14.9278 6.79664Z"
        fill="#D1884F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.38647 6.99701C6.38647 7.59069 6.78307 8.12226 7.40869 8.48013L6.97513 9.29672V11.3635C6.97513 11.6369 7.17857 11.8583 7.43013 11.8583C7.68169 11.8583 7.88513 11.6367 7.88513 11.3635V9.72001L8.35151 8.84151C8.64966 8.91019 8.96991 8.9476 9.30307 8.9476C10.9139 8.9476 12.2197 8.07435 12.2197 6.99722C12.2197 5.9201 10.9115 5.04663 9.30307 5.04663C7.6946 5.04663 6.38647 5.91988 6.38647 6.99701Z"
        fill="url(#paint0_linear)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.40874 8.47966L7.20968 8.35453C6.69999 8.00344 6.38674 7.5246 6.38674 6.99675C6.38674 5.91963 7.69268 5.04638 9.30334 5.04638C10.914 5.04638 12.2199 5.91963 12.2199 6.99675C12.2199 8.07388 10.914 8.94713 9.30334 8.94713C8.98316 8.94779 8.66394 8.9122 8.35178 8.84103L7.8854 9.71954V11.3632C7.8854 11.6367 7.68196 11.858 7.4304 11.858C7.17884 11.858 6.9754 11.6364 6.9754 11.3632V9.29647L7.40896 8.47988L7.40874 8.47966ZM6.51078 9.305V11.363C6.51078 11.9153 6.92246 12.3631 7.43018 12.3631C7.9379 12.3631 8.34959 11.9153 8.34959 11.3634V9.85516L8.59153 9.3995C8.82706 9.43495 9.06493 9.45265 9.30312 9.45244C10.1781 9.45244 10.9962 9.21575 11.6087 8.80647C12.2134 8.40222 12.6841 7.7766 12.6841 6.99697C12.6841 6.21735 12.2132 5.59216 11.6087 5.18747C10.9967 4.77841 10.1803 4.5415 9.30312 4.5415C8.42593 4.5415 7.60956 4.77841 6.99749 5.18747C6.39287 5.59172 5.92212 6.21735 5.92212 6.99654C5.92212 7.68079 6.2824 8.24428 6.78312 8.6481L6.5764 9.03747C6.55453 9.07335 6.54096 9.11185 6.52981 9.15341C6.51624 9.20328 6.50793 9.25447 6.51099 9.30522L6.51078 9.305Z"
        fill="#633001"
      />
      <path
        d="M7.2981 6.17542C7.2981 6.73323 7.95172 7.18604 8.75781 7.18604C9.56391 7.18604 10.2175 6.73367 10.2175 6.17542C10.2175 5.61717 9.56391 5.16479 8.75781 5.16479C7.95172 5.16479 7.2981 5.61717 7.2981 6.17542V6.17542Z"
        fill="#9E7200"
      />
      <path
        d="M7.2981 5.74231H10.2175V6.17543H7.2981V5.74231Z"
        fill="#9E7200"
      />
      <path
        d="M7.2981 5.74219C7.2981 6.3 7.95172 6.75238 8.75781 6.75238C9.56391 6.75238 10.2175 6.3 10.2175 5.74219C10.2175 5.18438 9.56391 4.73157 8.75781 4.73157C7.95172 4.73157 7.2981 5.18394 7.2981 5.74219V5.74219Z"
        fill="#F0B90B"
      />
      <path
        d="M8.20361 5.62056L8.61486 5.33575C8.65656 5.30632 8.70634 5.29053 8.75738 5.29053C8.80841 5.29053 8.8582 5.30632 8.89989 5.33575L9.31114 5.62056C9.39318 5.67743 9.39318 5.80737 9.31114 5.86403L8.89989 6.14884C8.8582 6.17826 8.80841 6.19406 8.75738 6.19406C8.70634 6.19406 8.65656 6.17826 8.61486 6.14884L8.20361 5.86403C8.12158 5.80715 8.12158 5.67722 8.20361 5.62056Z"
        fill="#9E7200"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.47594 4.60162C7.82528 4.35968 8.27963 4.22668 8.75738 4.22668C9.23513 4.22668 9.68925 4.35968 10.0388 4.60162C10.3827 4.83962 10.6815 5.23053 10.6815 5.74218V6.17531C10.6815 6.68718 10.3827 7.07787 10.0388 7.31587C9.68947 7.55759 9.23513 7.69081 8.75738 7.69081C8.27963 7.69081 7.8255 7.55781 7.47594 7.31587C7.13206 7.07787 6.83325 6.68697 6.83325 6.17531V5.74218C6.83325 5.23031 7.13206 4.83962 7.47594 4.60162V4.60162ZM8.75738 4.732C7.95128 4.732 7.29766 5.18437 7.29766 5.74262V6.17575C7.29766 6.73356 7.95128 7.18637 8.75738 7.18637C9.56347 7.18637 10.2171 6.734 10.2171 6.17575V5.74262C10.2171 5.18481 9.56347 4.732 8.75738 4.732Z"
        fill="#633001"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.33457"
        y1="5.11204"
        x2="9.33457"
        y2="11.8071"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9F4A08" />
        <stop offset="0.37" stop-color="#7D3900" />
        <stop offset="1" stop-color="#8D4104" />
      </linearGradient>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.868652)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default CAKE;
